<script lang="ts" setup>
const {
  modelValue,
  options,
} = defineProps<{
  size?: 'md' | 'lg' | string
  label?: string
  options?: any
  modelValue?: any
  title?: string
  subtitle?: string
}>()

const emit = defineEmits(['update:modelValue'])
const multiple = ref<any>([])

watch(() => modelValue, (newValue) => {
  multiple.value = newValue
})
watch(multiple, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<template>
  <div class="select-widget">
    <div v-if="title" class="title text-base">
      {{ title }}
    </div>
    <div class="stake-list">
      <div v-for="(option, index) in options" :key="index">
        <div class="select-menu__item">
          <slot name="option" :option="option" :index="index" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.select-widget {
  width: 100%;
  overflow: hidden;

  .title {
    color: $black;
    font-family: 'Noto Sans', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 18px;

    @media (max-width: $breakpoint-xs) {
      font-size: 14px;
    }

    span {
      color: $zinc-400;
    }
  }

  .stake-list {
    height: 100%;
    border-top: 1px solid $gray-02;
    overflow: auto;

    @media (max-width: $breakpoint-xs) {
      max-height: 360px;
    }
  }
}
.fill-space {
  flex: 1;
}
</style>
